// Libellés français centralisés pour toutes les valeurs techniques (enums) affichées à l'écran.
export const CATEGORY_LABEL = { pregnant: "Femme enceinte", child: "Enfant 0-3 ans", elderly: "Troisième âge", general: "Patient général", all: "Toutes catégories" };
export const ROLE_LABEL = {
  super_admin: "Super-Admin KWIKILA", hospital_admin: "Admin hôpital", doctor: "Médecin",
  nurse: "Infirmier(e)", caregiver: "Aide-soignant(e)", secretary: "Secrétariat", ministry: "Ministère de la Santé",
};
export const ROLE_COLOR = { hospital_admin: "#1E4631", doctor: "#D96C4A", nurse: "#2E7D32", caregiver: "#5B8DB8", secretary: "#E3A72F", super_admin: "#7A8471", ministry: "#2E5C7E" };
export const SMS_TYPE_LABEL = {
  welcome: "Bienvenue", reminder: "Rappel RDV", "reminder-15d": "Rappel J-15", "reminder-3d": "Rappel J-3", "reminder-45m": "Rappel 45 min",
  campaign: "Campagne", vaccine: "Campagne vaccinale", advice: "Conseil santé", ad: "Publicité santé", alert: "Alerte", manual: "Manuel",
};
export const SMS_STATUS_LABEL = { "sent (MOCK)": "envoyé (simulation)", sent: "envoyé", failed: "échec", pending: "en attente" };
export const CAMPAIGN_TYPE_LABEL = { campaign: "Campagne", vaccine: "Campagne vaccinale", ad: "Publicité santé", advice: "Conseil santé", alert: "Alerte sanitaire" };
export const PLAN_LABEL = { trial: "Essai gratuit", basic: "Basic", pro: "Pro", premium: "Premium", enterprise: "Premium", pilot: "Pilote", standard: "Standard" };
export const HOSPITAL_STATUS_LABEL = { active: "Actif", pending: "En attente", inactive: "Inactif" };
export const PATIENT_STATUS_LABEL = { active: "Actif", external: "Externe", hospitalized: "Hospitalisé", deceased: "Décédé" };
export const APPT_STATUS_LABEL = { scheduled: "À venir", done: "Terminé", cancelled: "Annulé", missed: "Manqué" };
export const PAYMENT_STATUS_LABEL = { active: "Actif", expired: "Expiré", pending: "En attente", COMPLETED: "Payé", FAILED: "Échec", ACCEPTED: "Accepté", SUBMITTED: "Soumis", cancelled: "Annulé", mock: "Simulé" };
export const LANG_LABEL = { fr: "Français", ln: "Lingala", sw: "Swahili", ts: "Tshiluba", kg: "Kikongo" };

export const SERVICES = [
  { id: "general", label: "Médecine générale" },
  { id: "urgences", label: "Urgences" },
  { id: "maternite", label: "Maternité" },
  { id: "pediatrie", label: "Pédiatrie" },
  { id: "pharmacie", label: "Pharmacie" },
];
export const SERVICE_LABEL = Object.fromEntries(SERVICES.map((s) => [s.id, s.label]));

export const SPECIALTIES = [
  "Médecine générale", "Gynécologie-Obstétrique", "Pédiatrie", "Néonatologie", "Chirurgie générale", "Orthopédie-Traumatologie",
  "Médecine interne", "Cardiologie", "Pneumologie", "Gastro-entérologie", "Néphrologie", "Endocrinologie-Diabétologie",
  "Neurologie", "Psychiatrie", "Dermatologie", "Ophtalmologie", "ORL", "Urologie", "Oncologie", "Hématologie",
  "Infectiologie", "Anesthésie-Réanimation", "Médecine d'urgence", "Radiologie-Imagerie", "Biologie médicale",
  "Santé publique", "Gériatrie", "Nutrition", "Stomatologie / Dentisterie", "Kinésithérapie",
];

export const TRIAGE_LEVELS = [
  { id: "rouge", label: "Rouge — Urgence vitale", color: "#C62828" },
  { id: "orange", label: "Orange — Très urgent", color: "#D96C4A" },
  { id: "jaune", label: "Jaune — Urgent", color: "#E3A72F" },
  { id: "vert", label: "Vert — Non urgent", color: "#2E7D32" },
];
export const TRIAGE_LABEL = Object.fromEntries(TRIAGE_LEVELS.map((t) => [t.id, t.label]));
export const TRIAGE_COLOR = Object.fromEntries(TRIAGE_LEVELS.map((t) => [t.id, t.color]));

export const label = (map, key) => (key == null || key === "" ? "—" : map[key] ?? key);
